import React from 'react';
import { PAYMENT_METHOD_CATEGORY } from 'Components/widgets/payment-info/PaymentInfo.const';
import { t } from 'Src/i18n';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
import { Title } from 'Components/frameworks/title/Title';
import { VoxpayForm } from './VoxpayForm/VoxpayForm';
type Props = {
  isDisabled: boolean;
  selectedPaymentMethod: string;
};
export const VoxpayBlock = ({ isDisabled, selectedPaymentMethod }: Props) => {
  return (
    <div className="mt-20 w-full">
      <Title className="mb-10" theme="title-brand-n2">
        {t('booking.partners.linkPayment.title')}
      </Title>
      <Capsule header="none">
        <VoxpayForm
          isDisabled={isDisabled}
          isCreditCardMethod={selectedPaymentMethod === PAYMENT_METHOD_CATEGORY.CREDIT_CARD}
        />
      </Capsule>
    </div>
  );
};
